import { Box, makeStyles, Popover, Typography } from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import { useMemo, useState } from "react";
import TravaLogo from "src/components/Icon/TravaLogo";
import { THEME_MODE } from "src/config/constants";
import { useConfigContext } from "src/context/config/configContext";
import ConnectedButton from "../ConnectedButton";
import HeaderTab from "../HeaderTab";
import ToggleNetworkButton from "../ToggleNetworkButton";
import ToggleThemeButton from "../ToggleThemeButton";

const useStyles = makeStyles((theme) => ({
  icon: {
    color: theme.palette.type === THEME_MODE.DARK ? "rgba(255, 255, 255, 0.65)" : "rgba(86, 100, 116, 0.8)",
  },
  mode: {
    color: theme.palette.text.hint,
  },
}));

export default function TabletHeader() {
  const cls = useStyles();

  const { themeMode } = useConfigContext();

  const mode = useMemo(() => {
    if (themeMode === THEME_MODE.DARK) return "Dark mode";
    else if (themeMode !== THEME_MODE.DARK) return "Light mode";
  }, [themeMode]);

  const [anchorEl, setAnchorEl] = useState(null);
  const tabletOpen = Boolean(anchorEl);
  const _id = tabletOpen ? "tablet-popover" : undefined;

  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center" height="100%">
        <Box display="flex" justifyContent="flex-start" alignItems="center">
          <TravaLogo />
          <HeaderTab />
        </Box>
        <Box onClick={(event) => setAnchorEl(event.currentTarget)}>
          <MenuIcon className={cls.icon} />
        </Box>
      </Box>
      <Popover id={_id} open={tabletOpen} anchorEl={anchorEl} onClose={() => setAnchorEl(null)}>
        <Box display="flex" justifyContent="flex-start" alignItem="flex-start" flexDirection="column">
          <ToggleNetworkButton style={{ marginBottom: "1rem" }} />
          <ConnectedButton style={{ marginBottom: "1rem" }} />
          <Box display="flex" justifyContent="space-between" width="100%">
            <Typography className={cls.mode}>{mode}</Typography>
            <ToggleThemeButton />
          </Box>
        </Box>
      </Popover>
    </>
  );
}
